import React, { useState } from "react";
import { Helmet } from "react-helmet";
import TopNav from "../../components/TopNav/TopNav";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Banner from "./Banner";
import sampleIMG from "../../Assets/newAsset/imaging/sam.webp";
import NewHeader from "../../components/NewHeader/NewHeader";
import "./PatientTetsimonial.css";
import patientBgBlue from "../../Assets/newAsset/patientTestimonial/layer.svg";
// import Testimonial1 from "../../Assets/newAsset/patientTestimonial/testimonial1.jpg";
// import Testimonial2 from "../../Assets/newAsset/patientTestimonial/testimonial2.jpg";
import { urlToRequest } from "loader-utils";
// import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
import SimpleForm from "../../components/chatbot/SimpleForm";

const testimonialArray = [
  {
    id: 1,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/28f28591-63ab-4ae6-ac7b-6f56b9e2e9ee.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/1bfbddd1-91c7-4c15-a61e-72dd08a4e2aa.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/f4d67a74-8946-42c2-ae8d-5bcae839799c.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/1af70409-c4c8-49d2-af3c-3126d9e105a0.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/fd5f2769-45b8-4d33-bd1b-a397118cd0d4.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/cdeb128a-8aac-4a3b-98da-fb7339567969.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/30fea26e-4549-4ddd-82ff-147523e2ca92.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/73d9bf06-7ce8-4fda-acdd-6ae85c1df17a.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/ddc29b9a-27e5-45e5-a6e3-6129e044b45f.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/a82fb1c6-ea95-4411-a904-dde78b410319.webp",
  },
  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/e5d12ae7-d3bd-40d3-96bd-f6cd3b6c05cb.webp",
  },

  {
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/c0dc9be5-d54f-4d10-9db0-ff8e44ee287f.webp",
  },
];
function PatientTestimonial() {
  const [showVideos, setVideos] = useState(true);
  const [showPhotos, setPhotos] = useState(false);
  const [showTestimonials, setTestimonials] = useState(false);

  const toggleActive = (e) => {
    console.log("clicked", e.target.outerText);
    if (e.target.outerText == "Videos") {
      setPhotos(false);
      setVideos(true);
      setTestimonials(false);
    } else if (e.target.outerText == "Photos") {
      setPhotos(true);
      setTestimonials(false);
      setVideos(false);
    } else {
      setPhotos(false);
      setTestimonials(true);
      setVideos(false);
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Patient Testimonials: Read Patient's feedback to know us better -
          Redcliffe Labs
        </title>
        <meta
          name="description"
          content="Send us your query and share your experience with us. It will help us to improve further and serve you better"
        />
      </Helmet>
      {/* <TopNav />
      <Header /> */}
      <NewHeader />
      {/* <Banner title="Our Success Stories" /> */}
      <div className="PattientBanner PattientBanner2">
        <h1 className="ourStory">
          <span>Our</span> <br /> Happy Patients
        </h1>
      </div>
      <div className="toggle-sections">
        <ul className="toggle-list">
          <li
            className={showVideos ? "currentTestimonial" : null}
            onClick={toggleActive}
          >
            Videos
          </li>
          {/* <li
            className={showPhotos ? "currentTestimonial" : null}
            onClick={toggleActive}
          >
            Photos
          </li> */}
          <li
            className={showTestimonials ? "currentTestimonial" : null}
            onClick={toggleActive}
          >
            Testimonials
          </li>
        </ul>
      </div>
      <div className="testimonialChild">
        {showVideos ? (
          <div className="testimonial_videos">
            <h3 className="videos_heading">Our Patient Videos</h3>

            <div className="videos_section">
              <iframe
                className="videosWidth"
                width="640"
                height="360"
                src="https://www.youtube.com/embed/14p44QjYxEY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <iframe
                width="640"
                className="videosWidth"
                height="360"
                src="https://www.youtube.com/embed/3yncACyGgFY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              <iframe
                className="videosWidth"
                width="640"
                height="360"
                src="https://www.youtube.com/embed/O1JZGHe-qaE"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
              <iframe
                width="640"
                className="videosWidth"
                height="360"
                src="https://www.youtube.com/embed/2ku7OtNHZYw"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              <iframe
                width="640"
                className="videosWidth"
                height="360"
                src="https://www.youtube.com/embed/ekh0d8xxnq0"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        ) : null}

        {showPhotos ? (
          <div className="photos_section">
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>{" "}
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>{" "}
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>{" "}
            <div className="photos">
              <img src={sampleIMG} alt={sampleIMG} width="100%" />
            </div>{" "}
          </div>
        ) : null}

        {/** T E S T I M O N I A L S */}
        {showTestimonials ? (
          <div className="testimonials_section">
            {testimonialArray.map((values, index) => {
              return (
                <div className="testimonialImages" key={index}>
                  <img src={values.img} alt={values.img} width="100%" />
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
      <div className="chatbot">
        <SimpleForm />
      </div>
      {/* <ScrolltoTop /> */}

      <Footer />
    </>
  );
}

export default {
  component: PatientTestimonial,
};
